import React from "react"
import { ContentfulPage } from "#/features/contentful/contentful-page"
import { StaticAssetID } from "#/lib/contentful/contentfulClient"

export default function SprintIntroPage(): JSX.Element {
  return <ContentfulPage entryId={StaticAssetID.SPRINTS_PAGE} flagEnabled={true} />
}
